import { noop } from 'lodash';
import InternalLink from '../../components/link/internal-link';
import NoopLink from '../../components/link/noop-link';
import { navigateToBlogOrPostPage } from '../navigate-to-section';

export default {
  Link: InternalLink,
  MembersLink: NoopLink,
  ProfileLink: NoopLink,
  SettingsLink: NoopLink,
  NotificationsLink: NoopLink,
  navigateToMembers: noop,
  navigateToProfile: noop,
  navigateToProfileSettings: noop,
  navigateToNotifications: noop,
  navigateToCreatePost: navigateToBlogOrPostPage,
  navigateToEditPost: navigateToBlogOrPostPage,
  navigateToMyDrafts: noop,
};
